import React from 'react';
import message_read from '../../../../assets/Main/message_read.svg';
import message_unread from '../../../../assets/Main/message_unread.svg';
import search from '../../../../assets/Main/icon_search.svg';
import star from '../../../../assets/Main/icon_star_yellow.svg';
import icon_user from '../../../../assets/Main/icon_user.svg';
import pin from '../../../../assets/Main/pin.svg'; 
import back from '../../../../assets/Main/arrow_left.svg'

import {
  formatTimeMoscow,
  getDisplayName,
  getOrderTitle,
  getChatLastMessageText,
} from './chatHelpers';
import { useNavigate } from 'react-router-dom';

const ChatSidebar = ({
  isMobile,
  chatsRef,
  handleChatsScroll,
  showSidebarScrollbar,
  sidebarThumbPosition,
  loading,
  chats,
  userRole,
  selectedChat,
  selectChat,
  suggestedLoading,
  suggestedExecutors,
  goToExecutorProfile,
  invitationsLoading,
  invitations,
  goToOrderDetails,
  processingInvitation,
  acceptInvitation,
  declineInvitation,
  chatSearchValue,
  setChatSearchValue,
  handleChatSearch,
}) => {
  const navigate = useNavigate();
  
  const getSelectedChatKey = () => selectedChat?.chatId || selectedChat?.id;
  const isSupportItem = (chat) => chat?.type === 'SUPPORT';

  // Сортируем чаты: сначала закрепленные, потом остальные
  const sortedChats = React.useMemo(() => {
    if (!chats || !Array.isArray(chats)) return [];
    
    // Сначала фильтруем НЕархивные чаты
    const nonArchivedChats = chats.filter(chat => !chat.archived);
    
    return [...nonArchivedChats].sort((a, b) => {
      // Чат поддержки всегда первый
      if (isSupportItem(a)) return -1;
      if (isSupportItem(b)) return 1;
      
      // Затем закрепленные чаты
      const aPinned = a.isPinned || false;
      const bPinned = b.isPinned || false;
      
      if (aPinned && !bPinned) return -1;
      if (!aPinned && bPinned) return 1;
      
      // Затем по дате последнего сообщения (новые сверху)
      const aTime = a.lastMessageAt ? new Date(a.lastMessageAt).getTime() : 0;
      const bTime = b.lastMessageAt ? new Date(b.lastMessageAt).getTime() : 0;
      return bTime - aTime;
    });
  }, [chats]);

  return (
    <div
      className={`sidebar ${isMobile ? 'mobile-sidebar-screen' : ''}`}
      ref={chatsRef}
      onScroll={handleChatsScroll}
    >
      <div className={`recent-chats ${showSidebarScrollbar ? 'with-scrollbar' : ''}`} style={{marginTop:(isMobile&&userRole==='EXECUTOR')?'80px':''}}>
        {isMobile && (
          <div className="mobile-chat-list-content">
            <img
              src={back}
              alt="Назад"
              onClick={() => navigate(-1)}
              style={{ cursor: 'pointer' }}
            />
            <h3 style={isMobile?{marginLeft:'35px'}:{}}>Недавние</h3>
          </div>
        )}

        
          <>
            <div className="chat-search" style={isMobile?{marginLeft:'10px'}:{}}>
              <div className="chat-search-input-wrapper">
                <span className="chat-search-icon">
                  <img src={search} alt="" />
                </span>
                <input
                  type="text"
                  placeholder="Найти чат"
                  className="chat-search-input"
                  value={chatSearchValue}
                  onChange={(e) => setChatSearchValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleChatSearch();
                    }
                  }}
                />
              </div>

              <button className="chat-search-button" onClick={handleChatSearch}>
                Найти
              </button>
            </div>

            { !isMobile && ( <h3>Недавние</h3> )}

          </>
        

        {loading && <div className="loading">Загрузка чатов...</div>}
        {!loading && sortedChats.length === 0 && <div className="no-chats">Нет активных чатов</div>}

        {sortedChats.map((chat) => {
          const chatKey = chat.chatId || chat.id;
          const selectedKey = getSelectedChatKey();
          const isSupport = isSupportItem(chat);
          
          const avatarSrc = isSupport
            ? icon_user
            : userRole === 'EXECUTOR'
              ? (chat.customer?.avatarUrl || icon_user)
              : (chat.selectedExecutorAvatarUrl || chat.executorAvatarUrl || icon_user);

          return (
            <div
              key={chatKey}
              className={`chat-item ${selectedKey === chatKey ? 'active' : ''} ${
                chat.unreadMessagesCount > 0 ? 'unread' : ''
              } ${chat.isPinned ? 'pinned' : ''}`}
              onClick={() => selectChat(chat)}
            >
              <div
                className="avatar chat-list-avatar"
                style={isMobile ? { width: '63px', height: '63px' } : {}}
              >
                <img
                  src={avatarSrc}
                  alt=""
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '7px',
                  }}
                />
              </div>

              <div className="chat-info">
                <div className="chat-name" style={{ margin: 0, maxWidth: '90%' }}>
                  {isSupport ? 'Чат поддержки RULLA' : getDisplayName(chat, userRole)}
                </div>

                <div className="order-titlee">
                  {isSupport ? 'Служба поддержки' : getOrderTitle(chat)}
                </div>

                <div className="last-message">
                  {isSupport
                    ? 'Здравствуйте! Это служба поддержки платформы Rulla.'
                    : getChatLastMessageText(chat, userRole)}
                </div>
              </div>

              <div className="chat-time">
                {chat.lastMessageAt ? formatTimeMoscow(chat.lastMessageAt) : ''}
              </div>

              <div className="chat-status-icon">
                <img
                  src={chat.lastMessageRead ? message_read : message_unread}
                  alt=""
                  className="status-icon"
                />
              </div>

              {/* Иконка пина для закрепленных чатов */}
              {chat.isPinned && !isSupport && (
                <div className="chat-pin-icon">
                  <img src={pin} alt="Закрепленный чат" />
                </div>
              )}

              {isSupport && (
                <div className="chat-pin-icon">
                  <img src={pin} alt="Закрепленный чат" />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Остальная часть компонента без изменений */}
      {userRole === 'CUSTOMER' && (
        <div className="suggested suggested-orders">
          <h3>Вас могут заинтересовать:</h3>

          {suggestedLoading && <div className="loading">Загрузка...</div>}
          {!suggestedLoading && suggestedExecutors.length === 0 && (
            <div className="empty-state-text">Пока нет подходящих специалистов</div>
          )}

          {suggestedExecutors.map((ex) => (
            <div
              key={ex.id}
              className="suggested-item"
              onClick={() => goToExecutorProfile(ex.id)}
              style={{ cursor: 'pointer' }}
            >
              <div className="avatar small">
                {ex.avatarUrl ? (
                  <img
                    src={ex.avatarUrl}
                    alt={ex.displayName}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '7px',
                    }}
                  />
                ) : (
                  <div className="avatar-placeholder" />
                )}
              </div>

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="suggested-name">{ex.displayName || 'Исполнитель'}</div>
                <div className="rating">
                  <img src={star} alt="★" />
                  {ex.rating ? Number(ex.rating).toFixed(1) : '—'} {ex.reviewsCount || 0}{' '}
                  {ex.reviewsCount === 1 ? 'отзыв' : 'отзывов'}
                </div>
                {ex.cityName && <div className="city">{ex.cityName}</div>}
              </div>
            </div>
          ))}
        </div>
      )}

      {userRole === 'EXECUTOR' && (
        <div className="suggested suggested-orders">
          <h3>Вам предложили заказы:</h3>

          {invitationsLoading && <div className="loading">Загрузка предложений...</div>}
          {!invitationsLoading && invitations.length === 0 && (
            <div className="empty-state-text">Нет активных предложений</div>
          )}

          {invitations.map((invitation) => (
            <div
              key={invitation.id}
              className="suggested-item invitation-item"
              onClick={() => goToOrderDetails(invitation.orderId)}
              style={{ cursor: 'pointer', display:'flex', flexDirection:'column' }}
            >
              <div className="suggested-item-head">
                <div className="avatar small">
                  {invitation.customerAvatarUrl ? (
                    <img
                      src={invitation.customerAvatarUrl}
                      alt={invitation.customerName || 'Заказчик'}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '7px',
                      }}
                    />
                  ) : (
                    <div className="avatar-placeholder" />
                  )}
                </div>

                <div className="suggested-item-meta">
                  <div className="suggested-name">{invitation.customerName || 'Заказчик'}</div>

                  <div className="order-titlee" style={{ marginTop: '4px' }}>
                    {invitation.orderTitle || 'Без названия заказа'}
                  </div>
                </div>
              </div>

              <button className='btn-about-order' onClick={()=>navigate(`/order/${invitation.orderId}`)}>Подробнее о заказе</button>
            </div>
          ))}
        </div>
      )}

      {showSidebarScrollbar && !isMobile && (
        <div className="sidebar-custom-scrollbar">
          <div className="sidebar-scroll-track">
            <div
              className="sidebar-scroll-thumb"
              style={{ transform: `translateY(${sidebarThumbPosition}px)` }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatSidebar;
